import { useState, useCallback } from "react";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { UPDATE_ITEM_OPTION } from "src/constants/mutations";
import { successToast } from "src/utils/toasts";

import { MutationCallbacks } from "src/interfaces/menu-items-props.interface";
import { UUID } from "src/types/shared.type";

export const useDeleteMenuItemOption = () => {
  const { axBe } = useAxiosInterceptor();
  const [isMenuItemDeleting, setIsMenuItemDeleting] = useState(false);

  const deleteMenuItemOptionMutation = useCallback(async (menuItemOptionCorrelationId: UUID, callbacks?: MutationCallbacks) => {
    setIsMenuItemDeleting(true);
    try {
      const variables = {
        updateItemOptionInput: {
          itemOptionCorrelationId: menuItemOptionCorrelationId,
          isActive: false,
        },
      };
      
      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: UPDATE_ITEM_OPTION,
        variables: variables,
      });
      
      if (data?.errors?.length) {
        throw data?.errors[0];
      }
      
      successToast("Item Option Deleted!");
      setIsMenuItemDeleting(false);
      callbacks?.onSuccess?.();
    } catch (err) {
      console.error("Error deleting option:", err);
      setIsMenuItemDeleting(false);
      callbacks?.onError?.(err);
    }
  }, [axBe]);

  return { deleteMenuItemOptionMutation, isMenuItemDeleting };
};

